import HromadneVyhodnoteniePripomienokPage from './HromadneVyhodnoteniePripomienokPage';

export default HromadneVyhodnoteniePripomienokPage;
